// extracted by mini-css-extract-plugin
export default {"paging":"paging_paging__MrKZr","no-records":"paging_no-records__amM5F","buttons":"paging_buttons__AN08b","records":"paging_records__u5Vgr","active":"paging_active__mR84w"};